import styled from "styled-components"

const BuscaRapidaIdSiconfi = styled.section`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  grid-gap: 0em;

  width: 100%;
  justify-content: end;

  /* ===== INPUT ===== */

  #busca-idsiconfi-form__input-idsiconfi {
    width: 11em;
    color: black;
  }

  #busca-idsiconfi-form__input-idsiconfi-label {
    font-family: Rawline, sans-serif;
    font-size: 14px;
    color: rgb(51, 51, 51);
  }

  #busca-idsiconfi-form__input-idsiconfi-helper-text {
    color: black;
  }

  /* ===== REMOVE BORDA DO OUTLINED (SÓ AQUI) ===== */

  .MuiOutlinedInput-root {
    background: transparent;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  /* Remove o "recorte" do legend que às vezes sobra */
  .MuiOutlinedInput-notchedOutline legend {
    width: 0;
  }

  /* ===== BOTÃO ===== */

  
  
  #btn-pesquisar{
    margin-left: 0 !important;
  }

  .MuiInput-underline::before {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .MuiInput-underline:hover::before{
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  }

  .MuiInput-underline.Mui-error::after{
    border-bottom-color: white;
  }
`;

export const S = {
  BuscaRapidaIdSiconfi,
};
